/*
 *Based on code found at https://dev.to/flexdinesh/cache-busting-a-react-app-22lk.  -- Jonathan Byrne 01/23/2020
 */
import React from "react";

import packageJson from "./meta.json";

global.buildFingerprint = packageJson.buildFingerprint;

class CacheBuster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: async () => {
        console.log("Forcing a refresh because a different build fingerprint was found on the server.");
        if (caches) {
          const names = await caches.keys();
          await Promise.all(names.map(name => caches.delete(name)));
        }

        // delete browser cache and hard reload
        window.location.reload(true);
      }
    };
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + "/meta.json")
      .then(response => response.json())
      .then(meta => {
        const latestVersion = meta.buildFingerprint;
        const currentVersion = global.buildFingerprint;

        if (latestVersion && currentVersion && latestVersion !== currentVersion) {
          this.setState({ loading: false, isLatestVersion: false });
        } else {
          this.setState({ loading: false, isLatestVersion: true });
        }
      });
  }

  render() {
    const { loading, isLatestVersion, refreshCacheAndReload } = this.state;

    return this.props.children({
      loading,
      isLatestVersion,
      refreshCacheAndReload
    });
  }
}

export default CacheBuster;
